export default () => {

  const config = {
    window: null,
    document: null,
    width: null,
    height: null,
  }

  const update = () => {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight|| e.clientHeight|| g.clientHeight;

    config.window = w;
    config.document = d;
    config.width = x;
    config.height = y;
  }

  const get = () => {
    return config
  }


  return { update, get }
}



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/helpers/client.js